const frontendURL = '/doc/aktDvk/';
const backendURL = '/api/akt_dvk/aktdvkheader/';
const name = 'Акт первинної, періодичної перевірки та прочищення двк';

const instance = {
  frontendURL,
  backendURL,
  name,
};

export default instance;
